let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6vjCL")).then(() => parcelRequire('dPV1h'));